module.exports = __webpack_public_path__ + "2dc97beedae441051054605bde23069b.eot";


//////////////////
// WEBPACK FOOTER
// ./application/font/SourceSansPro-LightItalic.eot
// module id = 32
// module chunks = 0